module.exports = __webpack_public_path__ + "static/media/contact-us-icon-yellow.137ee5ee.svg";